import { Box, SxProps } from "@mui/material";
import { ReactNode } from "react";
import MUITableCell from '@mui/material/TableCell'
import useGetBreakpoint from "../../hooks/useGetBreakpoint";

type Props = {
    children?: ReactNode,
    sx?: SxProps,
    basis?: number,
    minBreakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

const TableCell = ({ children, sx, minBreakpoint = 'xs', basis=100 }: Props) => {     
    const { breakpoint } = useGetBreakpoint();

    if (minBreakpoint === 'sm' && breakpoint === 'xs') return null;
    if (minBreakpoint === 'md' && (breakpoint === 'xs' || breakpoint === 'sm')) return null;
    if (minBreakpoint === 'lg' && (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md')) return null;    
    if (minBreakpoint === 'xl' && (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md' || breakpoint === 'lg')) return null;    

    return (
        <Box sx={{ ...sx, flexBasis: `${basis}%` }}>
            {children}
        </Box>
    )
}

export default TableCell;